import { v4 as uuid } from 'uuid';
import { PlaceMenuItemKey } from '../../constants/placeMenuItemKeys';
import { USER_DIALOG_ACTION_TYPES } from '../../constants/userDialog.constants';

export const showAddEditPlace = ({
  placeId = null,
  initialAddressId = null,
  requestId = uuid(),
  closeOnSave = false,
  initialMenuKey = PlaceMenuItemKey.EDIT_PLACE,
} = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.SHOW_ADD_EDIT_PLACE,
  payload: { placeId, initialAddressId, requestId, closeOnSave, initialMenuKey },
});

export const hideAddEditPlace = (requestId = null) => ({
  type: USER_DIALOG_ACTION_TYPES.HIDE_ADD_EDIT_PLACE,
  payload: { requestId },
});

export const placeSaved = (place, { requestId = null, isEditMode = false } = {}) => ({
  type: USER_DIALOG_ACTION_TYPES.PLACE_SAVED,
  payload: { place, requestId, isEditMode },
});
